import React from 'react';
import './ContactItem.css'

const ContactItem = (props) => {
    const imageName = props.number !== undefined ? props.number.replace("+","") +'.png' : "Andrea.png"
    return (
        // To do
        <div className={"contact-item"} style={{ backgroundColor: props.selectedContact === props.name ?  "rgb(192, 192, 192)" : ""}} onClick={()=>{props.setSelectedContact(props.name); props.setShowContact(false)}}>
            <img src={require('../../src/assets/'+imageName)} className="contact-image" alt="homme"></img>  
            <div className="contact-name">
                {props.name}
            </div>
        </div>
    );
}

export default ContactItem